import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Container, Link } from "@mui/material";

import './contextPanel.css';

export const ContextPanel = () => (
  <Container className='context-panel-container'>
    <Container className='context-panel-card'>
      <Accordion className='context-panel-accordion'>
        <AccordionSummary expandIcon={<ExpandMore/>}>
          <h2 className='context-panel-title'>About - New Features! Automatic vouches!</h2>
        </AccordionSummary>
        <AccordionDetails><p>New features:</p>

          <p><b><u>Automatic vouches!</u></b></p>

          <p>
            There is <a href='https://d2rapi.fly.dev/'>an API</a> that automatically retrieves the Terror Zone from the game. 
            Although I'm not sure exactly how it extracts the info, it seems very reliable so I've decided to integrate it with this site.
            This means that the current Terror Zone will be published immediately on the hour under the "ShalzuthAPI" user, and notifications will be sent to Discord.
            I still want to keep this site running in case that API ever goes down, we'll have community vouches to fall back on.
            So if you notice the notifications stop, please resume vouching manually!
          </p>

          <p><b><i><u>Older updates:</u></i></b></p>

          <p><b><u>You can now join the Discord in order to get notifications when your favourite zones are terrorized!</u></b></p>

          <p><Link href='https://discord.gg/eXFNNa3z7X'>https://discord.gg/eXFNNa3z7X</Link></p>

          <p><b><u>You can now log in via your Discord!</u></b></p>

          <p>
            This app only needs permission to confirm your identity,
            then it uses your Discord identity to track your vouches over time.
          </p>

          <p>
            Once you've identified yourself via discord, you can now start earning trust for correctly vouching the Terror Zone!
            Every person/anonymous user starts with 10 trust. 
            If you're logged in via discord, you will gain 5 trust at the end of the hour if you vouched the correct zone!
            The more trust you accumulate the more weight your vouch gives. 
            Plus you get a fun crown next to your name that legend says changes colour the more trust you have!
          </p>

          <p>Next step is notifications for certain zones, that's coming soon!</p>

          <p><b><u><i>About Terror Tracker:</i></u></b></p>

          <p>Terror Tracker is a community-powered tracker for Terror Zones in Diablo II: Resurrected.</p>

          <p>
            Its intent is to provide a way to check the current Terror Zone without having to log in. 
            It relies on community members to vouch the current Terror Zone. 
            The zone with the most vouches is most likely to be the current Terror Zone.
          </p>

          <p>
            Any player can vouch once per hour. 
            All players' vouches will be aggregated and displayed.
            At the end of each hour, the data will reset and players can begin to vouch again.
          </p>

          <p>
            At first it will rely on community trust to ensure the accuracy of the data.
            Eventually I will add features to improve the accuracy.
          </p>

          <p>Coming soon:</p>
          <ul>
            <li><span className='strikethrough'>Terror Zone History</span> Completed!</li>
            <li><span className='strikethrough'>Ability to subscribe and get notified when the Terror Zone is in specific zones</span> Completed!</li>
            <li><span className='strikethrough'>Accounts and rewards for correct vouches</span> Completed!</li>
            <li><span className='strikethrough'>Trust system based on players' vouch history</span> Completed!</li>
          </ul>
        </AccordionDetails>
      </Accordion>
    </Container>
  </Container>
)